import { render, staticRenderFns } from "./PeopleDivisionCard.vue?vue&type=template&id=f7723a0e&scoped=true&"
import script from "./PeopleDivisionCard.vue?vue&type=script&lang=js&"
export * from "./PeopleDivisionCard.vue?vue&type=script&lang=js&"
import style0 from "./PeopleDivisionCard.vue?vue&type=style&index=0&id=f7723a0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7723a0e",
  null
  
)

export default component.exports